"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _exceljs = _interopRequireDefault(require("exceljs"));
var _validators = require("./validators");
var _calculateTotal = _interopRequireDefault(require("../calculateTotal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const generateInterFace = (schema, translate) => {
  let interFace = {};
  Object.keys(schema).forEach((item, i) => {
    interFace[item] = {
      type: schema[item].type,
      displayText: translate(`benchmarking.survey.employee.entry-form.${item}`)
    };
  });
  return interFace;
};
const mapColumnsAndCheckTypes = async _ref => {
  let {
    data,
    submit,
    schema,
    translate,
    // dropdownOptions,
    submitInterval,
    submitChunkSize,
    onSubmitIntervalStart,
    onSubmitIntervalEnd,
    onSubmitFinish
  } = _ref;
  let hasErrors = false;
  const interFace = generateInterFace(schema, translate);
  let invalidEmployees = [];
  const employeesFromExcel = data.slice(1);

  // check if some columns are missing
  let properties = [];
  let headerValues = [];
  let invalidColumns = [];
  let extraCols = [];
  let expectedColumnName = Object.keys(interFace).map(propery => interFace[propery].displayText);
  data[0].forEach(userSuppliedColumnName => {
    if (!expectedColumnName.includes(userSuppliedColumnName)) {
      extraCols.push(userSuppliedColumnName);
    } else {
      properties.push(Object.keys(interFace).find(key => interFace[key].displayText === userSuppliedColumnName));
      headerValues.push(userSuppliedColumnName);
    }
  });
  if (extraCols.length > 0) {
    let formatedExtraCols = extraCols.map(colName => {
      return {
        content: colName,
        children: [{
          content: translate('benchmarking.survey.import-assistent.invalid-columns.title')
        }]
      };
    });
    invalidColumns = [...formatedExtraCols];
  }
  data.forEach((employee, i) => {
    if (i === 0) {
      if (Object.keys(interFace) !== properties) {
        let invalidColumnNames = Object.keys(interFace).filter(e => !properties.includes(e));
        invalidColumnNames.forEach(name => {
          let invalidColError = {
            content: translate(`benchmarking.survey.employee.entry-form.${name}`),
            children: [{
              content: translate('benchmarking.survey.employee.error.schema-required')
            }]
          };
          invalidColumns.push(invalidColError);
        });
      }
    }
  });
  if (invalidColumns.length > 0) {
    return new Promise(resolve => resolve({
      invalidEmployees: invalidColumns,
      invalidColumns: true
    }));
  }
  employeesFromExcel.forEach(emp => {
    let invalidEmployee = {};
    let propertiesThatMightBeInvalid = {
      yearOfBirth: (0, _validators.yearValidator)(emp[1]),
      employmentGrade: (0, _validators.workPercentageValidator)(emp[2]),
      sex: (0, _validators.genderValidator)(emp[3]),
      employmentLevel: (0, _validators.employeementTypeValidator)(emp[4]),
      employmentStatus: (0, _validators.statusValidator)(emp[5]),
      specXFunc: (0, _validators.employeeFunctionValidator)(emp[6])
    };
    for (const key in propertiesThatMightBeInvalid) {
      if (!propertiesThatMightBeInvalid[key]) {
        invalidEmployee[key] = translate(`benchmarking.survey.import-assistent.invalid-employee.${key}`);
      }
    }
    if (Object.keys(invalidEmployee).length > 0) {
      const employeeName = emp[0];
      invalidEmployee.name = employeeName;
      invalidEmployees.push(invalidEmployee);
    }
  });
  if (invalidEmployees.length > 0) {
    invalidEmployees = invalidEmployees.map(invalidEmployee => {
      const {
        name,
        ...rest
      } = invalidEmployee;
      const item = {
        content: name,
        children: []
      };
      for (const property in rest) {
        item.children.push({
          content: translate(`benchmarking.survey.employee.table.${property}`) + ': ' + translate(`benchmarking.survey.import-assistent.invalid-employee.${property}`)
        });
      }
      return item;
    });
  }
  const divideArrayToChunks = (arrayToDivide, chunkSize) => {
    let chunks = [];
    for (let i = 0; i < arrayToDivide.length; i += chunkSize) {
      let subArray = arrayToDivide.slice(i, i + chunkSize);
      chunks.push(subArray);
    }
    return chunks;
  };
  async function submitWithDelay(employees) {
    let promises = [];
    for (let i = 0; i < employees.length; i++) {
      let promise = submit(employees[i]);
      promises.push(promise);
    }
    return await Promise.all(promises);
  }
  const readyForSubmit = [];
  data.forEach((employee, i) => {
    if (i === 0) {
      return;
    }
    let preparedEmployee = {};
    let hasErrors = false;
    let employeeName = '';
    employee.forEach((item, j) => {
      // // Determine the column key; if not found and this is the first column, assume it's 'nameOrNum'
      const columnKey = properties[j] || (j === 0 ? 'nameOrNum' : undefined);
      if (columnKey === 'nameOrNum') {
        // Force conversion to string even if a number is provided
        const strVal = item != null ? item.toString() : '';
        employeeName = strVal;
        preparedEmployee['nameOrNum'] = strVal;
        return;
      }
      if (!isNaN(item)) {
        item = Number(item);
      }
      const alreadyValidatedProperties = ['yearOfBirth', 'employmentGrade', 'sex', 'employmentLevel', 'employmentStatus', 'specXFunc'];
      if (!alreadyValidatedProperties.includes(properties[j])) {
        if (properties[j] === 'remarks') {
          preparedEmployee[properties[j]] = item ? item.toString() : '';
        } else if (typeof item === interFace[properties[j]].type) {
          preparedEmployee[properties[j]] = item;
        } else {
          hasErrors = true;
          let children = translate(`benchmarking.survey.employee.entry-form.${properties[j]}`) + ' : ' + translate('benchmarking.survey.employee.error.incorrect-data-type', {
            item
          });
          let invalidEmployeeObject = {
            content: employeeName,
            children: [{
              content: children
            }]
          };
          let index = invalidEmployees.findIndex(e => e.content === employeeName);
          if (index >= 0) {
            invalidEmployees[index].children.push({
              content: children
            });
          } else {
            invalidEmployees.push(invalidEmployeeObject);
          }
        }
      } else {
        preparedEmployee[properties[j]] = item;
      }
    });
    if (!hasErrors) {
      (0, _calculateTotal.default)(preparedEmployee, 'yearlyPresenceTime');
      (0, _calculateTotal.default)(preparedEmployee, 'payroll');
      readyForSubmit.push(preparedEmployee);
    }
  });
  if (invalidEmployees.length > 0) {
    return new Promise(resolve => resolve({
      invalidEmployees,
      invalidColumns: false
    }));
  }
  if (readyForSubmit.length > submitChunkSize) {
    let employees = [];
    let employeeChunks = divideArrayToChunks(readyForSubmit, submitChunkSize);
    for (let i = 0; i < employeeChunks.length; i++) {
      const isLastInterval = i === employeeChunks.length - 1;
      let newlyCreatedEmployees = await submitWithDelay(employeeChunks[i], submitInterval, isLastInterval);
      employees.push(newlyCreatedEmployees);
      if (!isLastInterval) {
        onSubmitIntervalStart();
      }
      let shouldContinue = await new Promise(resolve => setTimeout(() => resolve(true), submitInterval));
      if (!isLastInterval) {
        onSubmitIntervalEnd();
      }
      if (shouldContinue) {
        continue;
      }
    }
    onSubmitFinish(employees.flat());
  } else {
    readyForSubmit.forEach(employee => submit(employee));
  }
};
const addHeadersAndExistingEmployees = (worksheet, interFace, existingEmployees) => {
  let headers = [];
  let row = 2;
  Object.keys(interFace).map(item => {
    headers.push({
      header: interFace[item].displayText,
      key: item,
      width: interFace[item].displayText.length
    });
  });
  worksheet.columns = headers;
  existingEmployees.forEach(employee => {
    headers.map((header, colIndex) => {
      const cell = `${String.fromCharCode(65 + colIndex)}${row}`;
      if (typeof employee[header.key] === 'object') {
        return worksheet.getCell(cell).value = employee[header.key].id;
      }
      return worksheet.getCell(cell).value = employee[header.key];
    });
    row++;
  });
};
const addDropdownDataByRow = (worksheet, data, startRow, title) => {
  const GLOBAL_FONT_STYLE = {
    name: 'Arial',
    size: 11
  };
  // Merge cells and add title
  worksheet.mergeCells(`A${startRow}:D${startRow}`);
  worksheet.getCell(`A${startRow}`).value = title;
  worksheet.getCell(`A${startRow}`).font = GLOBAL_FONT_STYLE;
  // Add instructions
  worksheet.getCell(`A${startRow + 1}`).value = 'Code';
  worksheet.getCell(`A${startRow + 1}`).font = GLOBAL_FONT_STYLE;
  worksheet.getCell(`B${startRow + 1}`).value = '';
  worksheet.getCell(`B${startRow + 1}`).font = GLOBAL_FONT_STYLE;
  const headers = Object.keys(data[0]);
  // Add id and options
  data.forEach((item, rowIndex) => {
    headers.forEach((header, colIndex) => {
      const row = startRow + 2 + rowIndex;
      // Code or Id column
      if (colIndex === 0) {
        const cell = `${String.fromCharCode(65 + colIndex)}${row}`;
        worksheet.getCell(cell).value = item[header];
        worksheet.getCell(cell).font = {
          color: {
            argb: 'e41b13'
          },
          ...GLOBAL_FONT_STYLE
        };
        worksheet.getCell(cell).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      }
      // Label column
      if (colIndex === 1) {
        const cell = `${String.fromCharCode(65 + colIndex)}${row}`;
        worksheet.getCell(cell).value = item[header];
        worksheet.getCell(cell).font = GLOBAL_FONT_STYLE;
      }
    });
  });
  return startRow + 3 + data.length;
};
const addInstructionsContent = (worksheet, interFace, options) => {
  let currentRow = 6; // Leave space for the Text at the top, start at row 6.

  Object.keys(interFace).forEach(key => {
    // Only map codes which are relevant
    let relevantOptions = options[key];
    if (relevantOptions) {
      currentRow = addDropdownDataByRow(worksheet, options[key], currentRow, interFace[key]?.displayText);
      currentRow += 2; // Add some space between sections
    }
  });
};
class ImportAssistantMethods {
  constructor(translate, schemaFromParent, dropdownOptions, existingEmployees) {
    this.defaultSchema = {
      nameOrNum: {
        type: 'string'
      },
      yearOfBirth: {
        type: 'number'
      },
      employmentGrade: {
        type: 'number'
      },
      sex: {
        type: 'string'
      },
      employmentLevel: {
        type: 'number'
      },
      employmentStatus: {
        type: 'number'
      },
      specXFunc: {
        type: 'number'
      },
      yearlyNominalTime: {
        type: 'number'
      },
      vacation: {
        type: 'number'
      },
      personalHolidays: {
        type: 'number'
      },
      illnessAccidentDoctor: {
        type: 'number'
      },
      militaryCivilService: {
        type: 'number'
      },
      maternityPaternityLeave: {
        type: 'number'
      },
      publicOffices: {
        type: 'number'
      },
      vocationalSchool: {
        type: 'number'
      },
      educationTraining: {
        type: 'number'
      },
      advertisingAcquisition: {
        type: 'number'
      },
      contest: {
        type: 'number'
      },
      managementLeadership: {
        type: 'number'
      },
      edvOperation: {
        type: 'number'
      },
      others: {
        type: 'number'
      },
      overUnderTime: {
        type: 'number'
      },
      baseSalary: {
        type: 'number'
      },
      addBenefits: {
        type: 'number'
      },
      varBenefits: {
        type: 'number'
      },
      remarks: {
        type: 'string'
      }
    };
    this.translate = translate;
    this.schema = schemaFromParent || this.defaultSchema;
    this.dropdownOptions = dropdownOptions;
    this.existingEmployees = existingEmployees;
  }
  async addBulkEmployees(data, submit, submitInterval, submitChunkSize, onSubmitIntervalStart, onSubmitIntervalEnd, onSubmitFinish) {
    return await mapColumnsAndCheckTypes({
      data,
      submit,
      schema: this.schema,
      translate: this.translate,
      // dropdownOptions: this.dropdownOptions,
      submitInterval,
      submitChunkSize,
      onSubmitIntervalStart,
      onSubmitIntervalEnd,
      onSubmitFinish
    });
  }
  generateExcelTemplate() {
    const interFace = generateInterFace(this.schema, this.translate);
    const workbook = new _exceljs.default.Workbook();
    const sheetName = this.translate('benchmarking.survey.employee.template.name');
    const sheet = workbook.addWorksheet(sheetName);
    addHeadersAndExistingEmployees(sheet, interFace, this.existingEmployees);
    const instructionsSheetName = this.translate('benchmarking.survey.employee.template.instructions.name');
    const instructionsSheet = workbook.addWorksheet(instructionsSheetName);
    const GLOBAL_FONT_STYLE = {
      name: 'Arial',
      size: 11
    };
    workbook.eachSheet(sheet => {
      sheet.eachRow(row => {
        row.eachCell(cell => {
          cell.font = Object.assign(cell.font || {}, GLOBAL_FONT_STYLE);
        });
      });
    });
    instructionsSheet.mergeCells('A1:D1');
    instructionsSheet.getCell('D1').value = this.translate('benchmarking.survey.employee.template.instructions.title');
    instructionsSheet.getCell('D1').font = {
      size: 16,
      bold: true,
      name: 'Arial'
    };
    instructionsSheet.getCell('D1').alignment = {
      wrapText: true,
      shrinkToFit: false,
      vertical: 'top'
    };
    instructionsSheet.getCell('D1').alignment = {
      wrapText: true,
      shrinkToFit: false,
      vertical: 'top'
    };
    instructionsSheet.mergeCells('A2:D2');
    instructionsSheet.getCell('D2').value = this.translate('benchmarking.survey.employee.template.instructions.paragraph');
    instructionsSheet.getCell('D2').font = {
      size: 12,
      bold: true,
      name: 'Arial'
    };
    instructionsSheet.getCell('D2').alignment = {
      wrapText: true,
      shrinkToFit: false,
      vertical: 'top'
    };
    instructionsSheet.mergeCells('A3:D3');
    instructionsSheet.mergeCells('A4:D4');
    instructionsSheet.getCell('D4').value = this.translate('benchmarking.survey.employee.template.instructions.subtitle');
    instructionsSheet.getCell('D4').font = {
      size: 12,
      bold: true,
      name: 'Arial'
    };
    instructionsSheet.getCell('D4').alignment = {
      wrapText: true,
      shrinkToFit: false,
      vertical: 'top'
    };
    // Add instructions and codes to the worksheet.
    addInstructionsContent(instructionsSheet, interFace, this.dropdownOptions);
    const pixelRatio = window.devicePixelRatio;
    if (pixelRatio < 2) {
      instructionsSheet.getRow(1).height = 36 * pixelRatio;
      instructionsSheet.getRow(2).height = 60 * pixelRatio;
      instructionsSheet.getRow(4).height = 36 * pixelRatio;
    } else {
      instructionsSheet.getRow(1).height = 24;
      instructionsSheet.getRow(2).height = 48;
      instructionsSheet.getRow(4).height = 24;
    }
    instructionsSheet.columns[1].width = 48;
    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetName;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
var _default = exports.default = ImportAssistantMethods;